import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LivePresentational from '../components/live';
import * as  liveActions from '../actions/liveActions';
import * as  commonActions from '../actions/common';

class Live extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      updatePage: "",
      EventLive: [],
    }
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    this.props.liveActions.getLive()
      .then(() => {
        this.setState({
          EventLive: this.props.live.live
        });

        if (this.props.live.live.raceCode === null) {
          this.props.commonActions.ResetUpdate();
        }
      });
  }

  componentWillReceiveProps(nextProps) {
    // if (nextProps.updatePage !== this.state.updatePage) {
    if (nextProps.updatePage.length > 0) {
      if (nextProps.updatePage.toLowerCase() === "update") {
        // this.props.commonActions.ResetUpdate();
        // this.setState({ updatePage: "" });
        this.getData();

        // if (window.location.pathname !== "/Live") {
        //   this.notify();
        // }
      }
    }
  }

  render() {
    return <LivePresentational {...this.state} {...this.props} />
  }
}

const mapStateToProps = (completeStore) => {
  return {
    dataLive: completeStore.dataLive,
    dataLive2: completeStore.dataLive2,
    live: completeStore.live,
    updatePage: completeStore.updatePage,
  };
};


const mapDispatchToProps = (dispatch) =>
  ({
    liveActions: bindActionCreators(liveActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  });

export default connect(mapStateToProps, mapDispatchToProps)(Live);